import React from 'react'
import './ReportingandAnalytics.css'
import ReportingAndAnalyticsOverview from './ReportingAndAnalyticsOverview'
import Teacher from '../../../assets/other_image/Reporting_and_Analytics.jpg'
import Letsgetintouch from '../BusinessProcessAndChangeManagement/Letsgetintouch'
import Banner from '../Banner/Banner'
import FloatingContactUs from '../../floting_contact/FloatingContactUs'
import { Helmet } from "react-helmet-async";
const ReportingandAnalytics = () => {
  return (
    <>
      {/* ✅ Meta Tags for SEO */}
     <Helmet>
      <title>Teamcenter Reporting &amp; Analytics Services in Pune | NexTech PLM</title>
      <meta name="description" content="Unlock actionable insights with Teamcenter Reporting and Analytics services in Pune, India. Drive informed decisions with Nextech PLM solutions." />
      <meta name="keywords" content="Teamcenter reporting analytics, PLM dashboards Pune, Teamcenter business intelligence, PLM data analytics India, Teamcenter reports customization" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href="https://nextechplm.com/teamcenter-reporting-analytics" />
      <meta property="og:site_name" content="NexTech PLM Solutions" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Teamcenter Reporting & Analytics Services in Pune | NexTech PLM" />
      <meta property="og:description" content="Unlock actionable insights with Teamcenter Reporting and Analytics services in Pune, India. Drive informed decisions with Nextech PLM solutions." />
      <meta property="og:url" content="https://nextechplm.com/teamcenter-reporting-analytics" />
      <meta name="twitter:title" content="Teamcenter Reporting & Analytics Services in Pune | NexTech PLM" />
      <meta name="twitter:description" content="Unlock actionable insights with Teamcenter Reporting and Analytics services in Pune, India. Drive informed decisions with Nextech PLM solutions." />
</Helmet>

    <section className="ReportingAndAnalytics-management">
        <Banner
        image={Teacher} // Pass the image for this page
        heading="Teamcenter Reporting and Analytics" // Pass the heading text for this page
      />
    <div>
         <FloatingContactUs />
      </div>

   
       <ReportingAndAnalyticsOverview/>
      <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
        <h4 className="ReportingAndAnalytics-page-heading">Unlock the Power :</h4>
        <h5 className="ReportingAndAnalytics-subheading">
          Discover the Transformative Benefits of Reporting and Analytics with NexTech!
        </h5>
        <ul className="custom-bullets">
          <li>Rapidly perform actionable analyses via KPIs, dashboards, detailed reports, and ad-hoc reports </li>
          <li>Rapid integrations, Ease of Use and Low TCO are some of Teamcenter Reporting and Analytics advantages over its competitors. </li>
          <li>
          Faster decision-making through meaningful reports and dashboards 
          </li>
          <li>Single view of Teamcenter data and other enterprise applications  </li>
          <li>Provide a single Integrated Intellectual Property (IP) Backbone. </li>
          <li>Introduce consistency and improve the accuracy of information to reduce time spent looking for information. </li>
          <li>Reduce total document management costs by improving access to information at the right time and in the right form. </li>
          <li>Helps to Schedule report and analysis. </li>
          <li>Visually appalling reports.   </li>
        </ul>
      </div>
      </section>
      <section>
      <div className="solutions container">
        <h4 className="ReportingAndAnalytics-page-heading">Teamcenter Solutions</h4>
        <ul className="custom-bullets">
          <li>TcRA setup and installation. </li>
          <li>Integration of TcRA with RAC and AW Client </li>
          <li>Trial with report generation on actual Business Use Cases  </li>
          <li>Full time Support on Product Consumption. </li>
          <li>Customization for Complex reports  </li>
        </ul>
      </div>

      <div className='best-practices container'>
        <h4 className="ReportingAndAnalytics-page-heading">Best Practices</h4>
        <p className='plmimplementationparagraph'>We help customer to develop a solutions using TCRA for business requirement like KPI tracking, dynamic analysis of reports like for engineering data, change management, schedule management and many more. </p>
      </div>
      </section>
      <section style={{ background: "#f5f7fa" }}>
      <div className="why-nextech container">
        <h4 className="ReportingAndAnalytics-page-heading">Why NexTech?</h4>
        <h5 className="ReportingAndAnalytics-subheading">For Reporting and Analytics (TCRA) Solution</h5>
        <ul className="custom-bullets">
          <li>
          Rapid implementation and actionable analyses facilitated by KPIs, dashboards, and detailed reports, leveraging TCRA's advantages of rapid integrations, ease of use, and low total cost of ownership.  
          </li>
          <li>
          Enhanced decision-making speed through meaningful reports and dashboards, providing a single view of Teamcenter data and other enterprise applications. 
          </li>
          <li>
          Introduction of consistency and accuracy in information, reducing time spent searching for data and lowering document management costs.  
          </li>
          <li>
          Seamless scheduling of reports and analyses, ensuring timely access to critical insights.     
          </li>
          <li>
          Tailored customization for complex reports and full-time support on product consumption, complemented by best practices implementation for optimal solution development.   
          </li>
        </ul>
      </div>
      </section>
        <Letsgetintouch/>
    </section>
  </>
  )
}

export default ReportingandAnalytics;
